import React, { Component, useEffect, useState } from "react";

// table(components)
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import BoostrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { PageOptions } from "../../components/PageParams";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { setReminder } from "../../../features/UserActions";
import { HttpJsonHeader } from "../../../features/Environments";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";

import { AiOutlinePlus, AiFillEdit, AiOutlineDelete } from "react-icons/ai";
import ConfirmDialog, { GetConfirmTitle } from "../../components/ConfirmDialog";
import styled from "styled-components";
import UserSettingPopup from "./UserSettingPopup";
import SqlSearchTypeA from "../../components/SqlSearchTypeA";
import SearchTypeB from "../../components/SearchTypeB";

export default function UserSetting(props) {
  // ** UserInfo + Popup Message ***/
  const formName = "ผู้ใช้ระบบ (USERS)";
  const userDetail = useSelector((state) => state.user.detail);
  const dispatch = useDispatch();
  // ** Main State ***/
  const [editor, setEditor] = useState({ show: false, action: null });
  const [data, setData] = useState([]);
  const [dataX, setDataX] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showConfig, setShowConfig] = useState({
    show: false,
    action: (e) => {},
  }); // Menu
  const [confirmAction, setConfirmAction] = useState(null);
  const [updateFlag, setUpdateFlag] = useState(true);
  const [searchA, setSearchA] = useState({ show: false, action: () => {} }); // SearchData
  const [searchB, setSearchB] = useState({ show: false, action: () => {} });

  useEffect(() => {
    if (updateFlag) {
      getData();
      setUpdateFlag(false);
    }
  }, [updateFlag]);

  useEffect(() => {
    getDataX();
  }, []);

  //----------------------------------------------------------------------
  // ** List All rows
  const getData = async () => {
    await axios
      .post(
        process.env.REACT_APP_API + "api/user/get-list",
        { BrchId: userDetail.brchid, SearchTxt: "" },
        HttpJsonHeader
      )
      .then((res) => {
        setData(res.data && res.data.rows);
      })
      .catch((err) =>
        dispatch(
          setReminder({ show: true, message: err.message, type: "error" })
        )
      );
  };
  //----------------------------------------------------------------------
  // Get component for selection on editting window
  const getDataX = async () => {
    await axios
      .post(
        process.env.REACT_APP_API + "api/user/get-user-component",
        {},
        HttpJsonHeader
      )
      .then((res) => {
        setDataX(res.data);
      })
      .catch((err) => dispatch(setReminder({ show: true, message: err })));
  };
  //----------------------------------------------------------------------
  // Actions
  // Save new Action
  const openAction = () => {
    setEditor({ show: true, action: null });
  };
  const actionNewData = () => {
    setSelectedRow({
      row: { userid: -1 },
      action: openAction,
    });
  };
  // Update Action
  const actionUpdate = (data) => {
    setSelectedRow({
      row: data,
      action: openAction,
    });
  };
  // Delete Action
  const actionDelete = (row) => {
    setShowConfirm(true);
    setConfirmAction({
      title: GetConfirmTitle("DELETE"),
      data: row,
      action: (row) => {
        let dataToUpdate = { ItemInfo: row, UserInfo: userDetail };
        axios
          .post(
            process.env.REACT_APP_API + "api/user/delete",
            dataToUpdate,
            HttpJsonHeader
          )
          .then((res) => {
            setUpdateFlag(true);
            dispatch(
              setReminder({
                show: true,
                message: "ยกเลิกเรียบร้อย",
                type: "success",
              })
            );
          })
          .catch((err) =>
            dispatch(
              setReminder({ show: true, message: err.message, type: "error" })
            )
          );
      },
    });
  };
  //----------------------------------------------------------------------
  //columns
  const getHeaderStyle = (wi) => {
    return {
      width: wi,
      background: "var(--table-header-back-color)",
    };
  };
  const customTextFilter = {
    placeholder: "...",
  };
  const formatEditBox = (x, row) => {
    return (
      <div>
        <OverlayTrigger
          placement="top"
          overlay={(props) => <Tooltip {...props}>แก้ไข</Tooltip>}
        >
          <Button
            variant="info"
            className="info-button"
            onClick={() => actionUpdate(row)}
          >
            <AiFillEdit />
          </Button>
        </OverlayTrigger>

        <OverlayTrigger
          placement="top"
          overlay={(props) => <Tooltip {...props}>ลบ</Tooltip>}
        >
          <Button
            variant="danger"
            className="info-button"
            onClick={() => {
              actionDelete(row);
            }}
          >
            <AiOutlineDelete />
          </Button>
        </OverlayTrigger>
      </div>
    );
  };
  //----------------------------------------------------------------------
  // ** Columns List
  const columns = [
    {
      dataField: "staffcode",
      text: "รหัสเจ้าหน้าที่",
      sort: true,
      headerStyle: () => getHeaderStyle("140px"),
      style: {
        border: "none",
        color: "var(--table-text-color)",
        textAlign: "left",
      },
      filter: textFilter(customTextFilter),
    },
    {
      dataField: "username",
      text: "ชือเข้าใช้",
      sort: true,
      headerStyle: () => getHeaderStyle("20%"),
      style: {
        border: "none",
        color: "var(--table-text-color)",
        textAlign: "left",
        paddingLeft: "10px",
      },
      filter: textFilter(customTextFilter),
    },
    {
      dataField: "staff_fullname",
      text: "ชื่อเจ้าหน้าที่",
      sort: true,
      headerStyle: () => getHeaderStyle("30%"),
      style: {
        border: "none",
        color: "var(--table-text-color)",
        textAlign: "left",
      },
      filter: textFilter(customTextFilter),
    },
    {
      dataField: "nickname",
      text: "ชื่อเล่น",
      sort: true,
      headerStyle: () => getHeaderStyle("15%"),
      style: {
        border: "none",
        color: "var(--table-text-color)",
        textAlign: "left",
        paddingLeft: "10px",
      },
      filter: textFilter(customTextFilter),
    },
    {
      dataField: "rulename",
      text: "สิทธิใช้งาน",
      sort: true,
      headerStyle: () => getHeaderStyle("30%"),
      style: {
        border: "none",
        color: "var(--table-text-color)",
        textAlign: "left",
      },
      filter: textFilter(customTextFilter),
    },
    {
      dataField: "brchshort",
      text: "เพื่อสาขา",
      sort: true,
      headerStyle: () => getHeaderStyle("30%"),
      style: {
        border: "none",
        color: "var(--table-text-color)",
        textAlign: "left",
      },
      filter: textFilter(customTextFilter),
    },
    {
      dataField: "box",
      text: "Edit",
      sort: true,
      headerStyle: () => getHeaderStyle("105px"),
      style: {
        border: "none",
        color: "var(--table-text-color)",
        textAlign: "center",
      },
      filter: textFilter(customTextFilter),
      formatter: formatEditBox,
    },
  ];

  //----------------------------------------------------------------------
  return (
    <div>
      <HBox>
        <OverlayTrigger
          placement="top"
          overlay={(props) => <Tooltip {...props}>เพิ่มข้อมูลใหม่</Tooltip>}
        >
          <Button
            variant="primary"
            style={{ margin: "5px" }}
            onClick={() => actionNewData()}
          >
            <AiOutlinePlus /> เพิ่มข้อมูลใหม่
          </Button>
        </OverlayTrigger>

        {/* <OverlayTrigger placement='top' overlay={(props)=> <Tooltip {...props}>ประเภท</Tooltip>}>                               
                    <Button variant = 'info'                    
                        style={{margin:'5px'}}
                        onClick={()=>actionNewData()} >
                        <AiOutlinePlus/> สิทธิใช้งานระบบ                  
                    </Button>  
                </OverlayTrigger>  */}

        <div className="table-caption-box-right-flex">{formName}</div>
      </HBox>

      <BoostrapTable
        bootstrap4
        keyField="userid"
        rowClasses={"table-next-rows-style"}
        data={data}
        columns={columns}
        striped
        hover
        condensed
        headerWrapperClasses="headerWrapper"
        wrapperClasses="bs-table-wrapper"
        bordered={true}
        pagination={paginationFactory(PageOptions)}
        filter={filterFactory()}
        // selectRow = {selectRow}
      />

      <UserSettingPopup
        {...{
          editor: [editor, setEditor],
          configState: [showConfig, setShowConfig],
          searchState: [searchA, setSearchA],
          searchB: [searchB, setSearchB],
          dataComponent: [dataX, setDataX],
          formName,
          selectedRow,
          setUpdateFlag,
        }}
      />
      <ConfirmDialog
        {...{ showConfirm, setShowConfirm, confirmAction, setConfirmAction }}
      />
      <SqlSearchTypeA {...{ winState: [searchA, setSearchA] }} />
      <SearchTypeB {...{ winState: [searchB, setSearchB] }} />
    </div>
  );
}

const HBox = styled.div`
  padding: 0px;
  display: flex;
`;
